import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, watch } from 'vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useFormatLocalData } from '@/composables/format-edit/useFormatLocalData'
import { provideRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import {
  provideRirekishoHistories,
  useRirekishoHistories
} from '@/composables/format-edit/useRirekishoHistories'
import MyprofileFavoritesCard from '@/components/format-edit/myprofile/MyprofileFavoritesCard.vue'
import MyprofileBest3Card from '@/components/format-edit/myprofile/MyprofileBest3Card.vue'
import MyprofileTypesCard from '@/components/format-edit/myprofile/MyprofileTypesCard.vue'
import MyprofileFreespaceCard from '@/components/format-edit/myprofile/MyprofileFreespaceCard.vue'
import MyprofileOutputCard from '@/components/format-edit/myprofile/MyprofileOutputCard.vue'
import RirekishoEduHistoryCard from '@/components/format-edit/rirekisho/RirekishoEduHistoryCard.vue'
import RirekishoJobHistoryCard from '@/components/format-edit/rirekisho/RirekishoJobHistoryCard.vue'
import type { BasicData } from '@/utils/format-edit/basicData'
import {
  createEmptyMyprofileFormatData,
  migrateMyprofileFormatData
} from '@/utils/format-edit/myprofileFields'


export default /*#__PURE__*/_defineComponent({
  __name: 'MyprofileEdit',
  props: {
    basicData: null,
    formatId: null,
    previewFormat: null,
    currentCardId: null,
    exampleSentences: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  basicData: BasicData
  formatId?: string
  previewFormat?: {
    errorMessages?: Record<string, string>
  } | null
  currentCardId?: string
  exampleSentences?: Record<string, unknown>
};



const { formLib } = useHostServices()

const { formatData, saveKey, saveName, changeCount } = useFormatLocalData({
  saveName: 'rirekisho',
  saveOtherName: 'shokumukeirekisho',
  createEmpty: createEmptyMyprofileFormatData,
  migrate: migrateMyprofileFormatData
})
provideRirekishoFormatData(formatData)

const histories = useRirekishoHistories(formatData)
provideRirekishoHistories(histories)

const previewErrors = computed(() => {
  if (!props.previewFormat || !props.previewFormat.errorMessages) return {}
  return props.previewFormat.errorMessages
})

watch(
  () => formatData.createDate,
  (newValue) => {
    if (newValue == null) return
    formatData.writeDate = formLib.dateFormat(
      newValue as Date,
      'yyyy年 m月 d日'
    )
  }
)

onBeforeMount(() => {
  if (formatData.createDate === null) {
    formatData.createDate = formLib.getToday()
  }
})

expose({
  saveName,
  saveKey,
  formatData,
  changeCount,
  addEducationalHistory: histories.addEducationalHistory
})

return { __sfc: true,props, formLib, formatData, saveKey, saveName, changeCount, histories, previewErrors, MyprofileFavoritesCard, MyprofileBest3Card, MyprofileTypesCard, MyprofileFreespaceCard, MyprofileOutputCard, RirekishoEduHistoryCard, RirekishoJobHistoryCard }
}

})